import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Stack
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';


const boxstyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 273,
  height: 175,
  bgcolor: 'background.paper',
  boxShadow: 24,
  outline: 'none',
  padding: '30px 32px',
  textAlign: 'center',
  boxSizing: 'border-box'
};

const ChangeStatusConflictModal = ({ open, onClose }) => {
  const handleClose = () => onClose?.();

  return (
    <Modal
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      hideBackdrop
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={boxstyle}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            color: 'grey.700',
            margin:0
          }}
        >
          <CloseIcon fontSize="small"/>
        </IconButton>

        {/* Header row */}
        <Stack
          direction="row"
          spacing={1}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 1,
            position:'absolute',
            top:8,
            left:7,
            padding:'8px 0 0 4px'
           }}
        >
          <CancelOutlinedIcon
          sx={{ color: '#D32F2F', fontSize: '18px',
            transform: 'translate(4px, -4px)'
           }} />
          <Typography
            id="modal-title"
            sx={{ color: '#D32F2F', fontWeight: 700, fontSize: '16px',padding:'5px'
             }}
          >
            Draft Task
          </Typography>
        </Stack>

        {/* Body text */}
        <Typography
          id="modal-description"
          sx={{
            fontSize: '14px',
            lineHeight: '1.35',
            margin: '14px 0 4px 0',
            textAlign:'left',
            padding: '8px 0 0 8px'
          }}
        >
          {
            `Productive Writing task must be Sent to Automarker before
              Test can be set to Pretesting, Queued to Live or Live`
          }
        </Typography>

        {/* CLOSE action */}
        <Button
          variant="text"
          sx={{ fontSize: '13px', fontWeight: 700, color: 'black' }}
          onClick={handleClose}
        >
          CLOSE
        </Button>
      </Box>
    </Modal>
  );
};

export default ChangeStatusConflictModal;